'use client';
import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkPopularSkuItem.module.css';

export function DevlinkPopularSkuItem({
  as: _Component = _Builtin.Link,
  showImageSource = true,
  imageSource = 'https://uploads-ssl.webflow.com/5fece0d001923a6386f248d6/6603322a71125ba72e6481a4_hp-popular-sku-img-tv-md.jpg',
  showImageSlot = false,
  imageSlot,
  title = 'Title',
  action = {},
}) {
  return (
    <_Component
      className={_utils.cx(_styles, 'ht-popular-sku-item')}
      button={false}
      block="inline"
      options={{
        href: '#',
      }}
      {...action}
    >
      {showImageSource ? (
        <_Builtin.Block className={_utils.cx(_styles, 'ht-popular-sku-item-img')} tag="div">
          <_Builtin.Image
            className={_utils.cx(_styles, 'ht-inner-img', 'ht-fit')}
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src={imageSource}
          />
        </_Builtin.Block>
      ) : null}
      {showImageSlot ? (
        <_Builtin.Block className={_utils.cx(_styles, 'ht-popular-sku-item-img')} tag="div">
          {imageSlot}
        </_Builtin.Block>
      ) : null}
      <_Builtin.Block className={_utils.cx(_styles, 'ht-popular-sku-item-text')} tag="div">
        {title}
      </_Builtin.Block>
    </_Component>
  );
}
